{
  "PROFILE_SETTINGS": {
    "LINK": "Paramètres de profil",
    "TITLE": "Paramètres de profil",
    "BTN_TEXT": "Mettre à jour le profil",
    "DELETE_AVATAR": "Supprimer l'avatar",
    "AVATAR_DELETE_SUCCESS": "L'avatar a été supprimé avec succès",
    "AVATAR_DELETE_FAILED": "Une erreur est survenue lors de la mise à jour des préférences, veuillez réessayer",
    "UPDATE_SUCCESS": "Votre profil a été mis à jour avec succès",
    "PASSWORD_UPDATE_SUCCESS": "Votre mot de passe a été modifié avec succès",
    "AFTER_EMAIL_CHANGED": "Votre profil a été mis à jour avec succès, veuillez vous reconnecter car vos identifiants de connexion ont été modifiés",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Image de la signature d'e-mail",
        "HINT": "Utilisée dans les signatures d'e-mail. {'{{'}email_signature_picture{'}}'} est remplacé par l'URL de cette image (pas une balise d'image) — utilisez-la comme source d'image (l'attribut src d'une balise img) dans votre signature ou la signature de la boîte de réception. Si elle n'est pas définie, rien n'est inséré.",
        "DELETE_SUCCESS": "L'image de la signature d'e-mail a été supprimée avec succès",
        "DELETE_FAILED": "Une erreur s'est produite lors de la suppression de l'image de la signature d'e-mail, veuillez réessayer"
      },
      "AVATAR": "Image de profil",
      "ERROR": "Veuillez corriger les erreurs du formulaire",
      "REMOVE_IMAGE": "Supprimer",
      "UPLOAD_IMAGE": "Téléverser une image",
      "UPDATE_IMAGE": "Mettre à jour l'image",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Votre adresse de courriel est votre identité et est utilisée pour vous connecter."
      },
      "SEND_MESSAGE": {
        "TITLE": "Raccourci clavier pour envoyer des messages",
        "NOTE": "Vous pouvez sélectionner un raccourci clavier (Entrée ou Cmd/Ctrl+Entrée) en fonction de vos préférences d'écriture.",
        "UPDATE_SUCCESS": "Votre profil a été mis à jour avec succès",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Entrer (<unk> )",
            "CONTENT": "Envoyez des messages en appuyant sur la touche Entrée au lieu de cliquer sur le bouton d'envoi."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Entrée (<unk> + <unk> )",
            "CONTENT": "Envoyez des messages en appuyant sur la touche Cmd/Ctrl + Entrée (<unk> + <unk>) au lieu de cliquer sur le bouton d'envoi."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Personnalisez l'apparence de votre tableau de bord.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Par défaut",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Langue du tableau de bord",
          "NOTE": "Remplacer la langue du compte pour votre propre tableau de bord. Laissez vide pour utiliser la valeur par défaut du compte.",
          "USE_ACCOUNT_DEFAULT": "Utiliser la valeur par défaut du compte",
          "API_SUCCESS": "La langue de votre tableau de bord a été mise à jour avec succès",
          "API_ERROR": "Une erreur s'est produite lors de la mise à jour de la langue du tableau de bord, veuillez réessayer"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Langue des messages",
          "NOTE": "Choisissez d'afficher les messages originaux ou leurs traductions",
          "ORIGINAL": "Original",
          "TRANSLATED": "Traduit"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Comportement du collage",
          "NOTE": "Choisissez comment le contenu collé doit être traité lors de la rédaction de messages",
          "UPDATE_SUCCESS": "Vos paramètres de collage ont été mis à jour avec succès",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Conserver toute la mise en forme",
              "DESCRIPTION": "Conservez toute la mise en forme, y compris les tableaux, les styles et autres éléments HTML lors du collage du contenu."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Texte avec liens uniquement",
              "DESCRIPTION": "Convertir en texte brut tout en préservant les liens cliquables lors du collage du contenu."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Texte brut uniquement",
              "DESCRIPTION": "Supprimer toute la mise en forme et convertir en texte brut lors du collage du contenu."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Hauteur de la boîte de réponse",
          "NOTE": "Définissez la hauteur minimale de la boîte de réponse en pourcentage de la hauteur de l'écran. S'applique uniquement aux conversations par e-mail.",
          "UPDATE_SUCCESS": "Vos paramètres de hauteur de la boîte de réponse ont été mis à jour avec succès",
          "PERCENT_LABEL": "Hauteur (% de la hauteur de l'écran)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Par défaut",
              "DESCRIPTION": "La boîte de réponse commence petite et s'agrandit au fur et à mesure que vous tapez."
            },
            "CUSTOM": {
              "HEADING": "Personnalisé",
              "DESCRIPTION": "La boîte de réponse occupe toujours au moins le pourcentage choisi de la hauteur de l'écran."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Navigation automatique vers la conversation suivante",
        "NOTE": "Basculer automatiquement vers la prochaine conversation ouverte après avoir résolu l'actuelle",
        "UPDATE_SUCCESS": "Paramètre de navigation automatique mis à jour avec succès"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Format d'aperçu des e-mails dans la liste des conversations",
        "NOTE": "Choisissez ce qui s'affiche dans la liste des conversations pour les conversations provenant des boîtes e-mail",
        "SUBJECT": "Objet",
        "SUBJECT_WITH_NOTE": "Objet et dernier message si c'est une note privée",
        "UPDATE_SUCCESS": "Le paramètre d'aperçu des e-mails a été mis à jour avec succès"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Désactiver les raccourcis clavier",
        "NOTE": "Désactiver tous les raccourcis clavier dans l'application",
        "UPDATE_SUCCESS": "Paramètre des raccourcis clavier mis à jour avec succès"
      },
      "FOLDER_ORDER": {
        "TITLE": "Ordre des dossiers",
        "NOTE": "Personnalisez l'ordre dans lequel les dossiers (vues personnalisées) apparaissent dans la barre latérale. Glissez-déposez pour réorganiser.",
        "NO_FOLDERS": "Aucun dossier personnalisé trouvé. Créez des dossiers pour organiser vos conversations."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Configuration de la barre latérale",
        "NOTE": "Personnalisez les sections qui apparaissent dans la barre latérale des conversations.",
        "SAVE_BUTTON": "Enregistrer la configuration",
        "UPDATE_SUCCESS": "Configuration de la barre latérale mise à jour avec succès",
        "UPDATE_ERROR": "Une erreur s'est produite lors de la mise à jour de la configuration de la barre latérale, veuillez réessayer",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Toutes les conversations",
          "ALL_CONVERSATIONS_DESC": "Afficher l'élément de menu Toutes les conversations dans la barre latérale",
          "INBOX": "Boîte de réception",
          "INBOX_DESC": "Afficher la boîte de réception principale avec les notifications non lues",
          "CONVERSATION_GROUPS": "Mentions et non traitées",
          "CONVERSATION_GROUPS_DESC": "Afficher les groupes de conversations Mentions et Non traitées",
          "FOLDERS": "Dossiers",
          "FOLDERS_DESC": "Afficher les vues personnalisées (dossiers) pour organiser les conversations",
          "TEAMS": "Équipes",
          "TEAMS_DESC": "Afficher les conversations filtrées par assignations d'équipe",
          "CHANNELS": "Boîtes de réception",
          "CHANNELS_DESC": "Afficher les conversations filtrées par boîte de réception",
          "LABELS": "Étiquettes",
          "LABELS_DESC": "Afficher les conversations filtrées par étiquettes"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Paramètres téléphone",
        "NOTE": "Entrez vos identifiants de connexion à votre système PBX.",
        "USERNAME": "Nom d'utilisateur",
        "PASSWORD": "Mot de passe",
        "SUBMIT": "Enregistrer",
        "USERNAME_INVALID": "Le nom d'utilisateur ne peut contenir que des lettres, des chiffres et . _ - + — sans espaces et sans adresse e-mail.",
        "API": {
          "USERNAME_INVALID": "Le nom d'utilisateur n'est pas un nom d'utilisateur SIP valide. Utilisez uniquement des lettres, des chiffres et . _ - + — sans espaces et sans adresse e-mail.",
          "USERNAME_TAKEN": "Ce nom d'utilisateur est déjà utilisé par un autre agent dans ce compte."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Signature du message personnel",
        "DESCRIPTION": "Créez une signature de message unique qui apparaîtra à la fin de chaque e-mail que vous envoyez. Vous pouvez également inclure une image en ligne.",
        "NOTE": "Créez une signature de message unique qui apparaîtra à la fin de chaque message que vous envoyez à partir de n'importe quelle boîte de réception. Vous pouvez également inclure une image en ligne, qui est prise en charge dans les boîtes de réception en direct, les e-mails et les API.",
        "BTN_TEXT": "Enregistrer la signature du message",
        "API_ERROR": "Impossible d'enregistrer la signature ! Réessayez",
        "API_SUCCESS": "Signature enregistrée avec succès",
        "IMAGE_UPLOAD_ERROR": "Impossible de télécharger l'image! Réessayez",
        "IMAGE_UPLOAD_SUCCESS": "L'image a été ajoutée avec succès. Veuillez cliquer sur Enregistrer pour enregistrer la signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "La taille de l'image doit être inférieure à {size}Mo"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Signature du message",
        "ERROR": "La signature du message ne peut pas être vide",
        "PLACEHOLDER": "Insérez ici votre signature personnelle."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Mot de passe",
        "NOTE": "Mettre à jour votre mot de passe réinitialisera vos connexions sur plusieurs appareils.",
        "BTN_TEXT": "Modifier le mot de passe"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Jeton d'accès",
        "NOTE": "Ce jeton peut être utilisé si vous construisez une intégration basée sur l'API",
        "COPY": "Copier",
        "REGENERATE": "Régénérer",
        "REGENERATE_SUCCESS": "Jeton d'accès régénéré avec succès. Veuillez mettre à jour toutes les intégrations utilisant l'ancien jeton.",
        "REGENERATE_CONFIRM_TITLE": "Régénérer le jeton d'accès ?",
        "REGENERATE_CONFIRM_MESSAGE": "Cela invalidera le jeton actuel. Toutes les intégrations utilisant l'ancien jeton cesseront de fonctionner."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Extension Chrome",
        "NOTE": "Installez notre extension Chrome pour recevoir des notifications riches concernant les appels téléphoniques entrants.",
        "INSTALL_BUTTON": "Installer l'extension",
        "ALREADY_INSTALLED": "Extension installée"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Aucun",
          "MINE": "Assigned",
          "ALL": "Tous",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Aucun",
          "ASSIGNED": "Conversations assignées",
          "ALL_CONVERSATIONS": "Toutes les conversations"
        },
        "DEFAULT_TONE": {
          "TITLE": "Sonnerie d'alerte :"
        },
        "CONDITIONS": {
          "TITLE": "Condition d'alerte :",
          "CONDITION_ONE": "Envoyer des alertes audio seulement si la fenêtre du navigateur n'est pas active",
          "CONDITION_TWO": "Envoyer des alertes toutes les 30s jusqu'à ce que toutes les conversations assignées soient lues"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "En savoir plus"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notifications par courriel",
        "NOTE": "Mettez à jour vos préférences de notification par courriel ici",
        "CONVERSATION_ASSIGNMENT": "Envoyer des notifications par courriel lorsqu'une conversation m'est assignée",
        "CONVERSATION_CREATION": "Envoyer des notifications par courriel quand une nouvelle conversation est créée",
        "CONVERSATION_MENTION": "Envoyer des notifications par courriel lorsque vous êtes mentionné dans une conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Envoyer des notifications par courriel lorsqu'un nouveau message est créé dans une conversation assignée",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Envoyer des notifications par courriel lorsqu'un nouveau message est créé dans une conversation assignée",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "Courriel",
        "PUSH": "Notifications push",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Un nouveau message est créé dans une conversation sans agent disponible",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Autoriser les notifications push pendant un appel",
        "TEST_PUSH": "Tester",
        "TESTING": "Test en cours...",
        "TEST_PUSH_DESCRIPTION": "Envoyer des notifications de test pour vérifier votre configuration",
        "TEST_NOTIFICATION_ERROR": "Échec de l'envoi de la notification de test. Veuillez réessayer.",
        "TEST_LOCAL_TITLE": "Notification de test (locale)",
        "TEST_LOCAL_BODY": "Ceci est une notification locale du navigateur. Si vous la voyez, les notifications du navigateur fonctionnent !"
      },
      "API": {
        "UPDATE_SUCCESS": "Vos préférences de notifications ont été mises à jour avec succès",
        "UPDATE_ERROR": "Une erreur est survenue lors de la mise à jour des préférences, veuillez réessayer"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notifications push",
        "NOTE": "Mettez à jour vos préférences de notification push ici",
        "CONVERSATION_ASSIGNMENT": "Envoyer des notifications push lorsqu'une conversation m'est assignée",
        "CONVERSATION_CREATION": "Envoyer des notifications push quand une nouvelle conversation est créée",
        "CONVERSATION_MENTION": "Envoyer des notifications push lorsque vous êtes mentionné dans une conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Envoyer des notifications push lorsqu'un nouveau message est créé dans une conversation assignée",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Envoyer des notifications par courriel lorsqu'un nouveau message est créé dans une conversation assignée",
        "HAS_ENABLED_PUSH": "Vous avez activé les notifications pour ce navigateur.",
        "REQUEST_PUSH": "Activer les notifications push",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Image de profil"
      },
      "NAME": {
        "LABEL": "Votre nom complet",
        "ERROR": "Veuillez entrer un nom complet valide",
        "PLACEHOLDER": "Veuillez entrer votre nom complet"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nom affiché",
        "ERROR": "Veuillez entrer un nom d’affichage valide",
        "PLACEHOLDER": "Veuillez entrer un nom d’affichage, il s’affichera dans les conversations"
      },
      "POSITION": {
        "LABEL": "Poste",
        "ERROR": "Veuillez entrer un poste valide",
        "PLACEHOLDER": "Veuillez entrer votre poste"
      },
      "CUSTOM_LINE": {
        "LABEL": "Ligne personnalisée",
        "ERROR": "Veuillez entrer une ligne personnalisée valide",
        "PLACEHOLDER": "Veuillez entrer votre ligne personnalisée"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilité",
        "STATUS": {
          "ONLINE": "En ligne",
          "BUSY": "Occupé",
          "OFFLINE": "Hors ligne"
        },
        "SET_AVAILABILITY_SUCCESS": "La disponibilité a bien été définie",
        "SET_AVAILABILITY_ERROR": "Impossible de définir la disponibilité, veuillez réessayer"
      },
      "EMAIL": {
        "LABEL": "Votre adresse de courriel",
        "ERROR": "Veuillez saisir une adresse de courriel valide",
        "PLACEHOLDER": "Veuillez entrer votre adresse de courriel, cela sera affiché dans les conversations"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Mot de passe actuel",
        "ERROR": "Veuillez entrer le mot de passe actuel",
        "PLACEHOLDER": "Veuillez entrer le mot de passe actuel"
      },
      "PASSWORD": {
        "LABEL": "Nouveau mot de passe",
        "ERROR": "Veuillez entrer un mot de passe de 6 caractères ou plus",
        "PLACEHOLDER": "Veuillez entrer un nouveau mot de passe"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirmer le nouveau mot de passe",
        "ERROR": "La confirmation du mot de passe doit correspondre au mot de passe",
        "PLACEHOLDER": "Veuillez saisir à nouveau votre mot de passe"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Modifier",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Signaler un bug",
    "SELECTOR_SUBTITLE": "Sélectionnez un compte dans la liste suivante",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Signaler un bug",
    "DESCRIPTION_LABEL": "Description du problème",
    "DESCRIPTION_PLACEHOLDER": "Décrivez le problème que vous avez rencontré...",
    "SUBMIT": "Envoyer le rapport",
    "SUBMITTING": "Envoi en cours...",
    "CANCEL": "Annuler",
    "SUCCESS": "Rapport de bug envoyé avec succès. Merci !",
    "ERROR": "Échec de l'envoi du rapport de bug. Veuillez réessayer.",
    "VALIDATION_ERROR": "Veuillez décrire le problème avant d'envoyer"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "jours d'essai restants.",
    "TRAIL_BUTTON": "Acheter Maintenant",
    "DELETED_USER": "Utilisateur supprimé",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Compte Suspendu",
      "MESSAGE": "Votre compte est suspendu. Veuillez contacter le support pour plus d'informations."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copier",
      "CODEPEN": "Ouvrir dans CodePen",
      "COPY_SUCCESSFUL": "Code copié dans le presse-papier avec succès"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Voir plus",
      "SHOW_LESS": "Voir moins"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Télécharger",
      "UPLOADING": "Téléversement...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Cette Story n'est plus disponible.",
      "RECORDING_UNAVAILABLE": "Cet enregistrement n'est plus disponible.",
      "DELETE_RECORDING": {
        "BUTTON": "Supprimer l'enregistrement de l'appel",
        "TITLE": "Supprimer l'enregistrement de l'appel ?",
        "DESCRIPTION": "Tous les enregistrements de cet appel seront définitivement supprimés du système téléphonique et ne pourront pas être restaurés. La transcription et le résumé de l'appel sont conservés.",
        "CONFIRM": "Supprimer",
        "SUCCESS": "Enregistrement de l'appel supprimé",
        "ERROR": "Impossible de supprimer l'enregistrement de l'appel. Veuillez réessayer."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Afficher sur la carte"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Envoyer"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Vérification...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Ajouter une boîte de réception"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "En cours de visualisation:",
    "SWITCH": "Commuter",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Conversations",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Toutes les conversations",
    "MENTIONED_CONVERSATIONS": "Mentions",
    "PARTICIPATING_CONVERSATIONS": "Conversations assignées",
    "UNATTENDED_CONVERSATIONS": "Sans suivi",
    "REPORTS": "Rapports",
    "SETTINGS": "Paramètres",
    "CONTACTS": "Contacts",
    "DATA_ASSISTANT": "Assistant de données",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Accueil",
    "AGENTS": "Agents",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Journaux d'audit",
    "WHATSAPP_TEMPLATES": "Modèles WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Boîtes de réception",
    "NOTIFICATIONS": "Notifications",
    "CANNED_RESPONSES": "Réponses standardisées",
    "INTEGRATIONS": "Intégrations",
    "PROFILE_SETTINGS": "Paramètres de profil",
    "ACCOUNT_SETTINGS": "Paramètres du compte",
    "APPLICATIONS": "Applications",
    "LABELS": "Étiquettes",
    "CUSTOM_ATTRIBUTES": "Attributs personnalisés",
    "AUTOMATION": "Automatisations",
    "MACROS": "Macros",
    "TEAMS": "Équipes",
    "BILLING": "Facturation",
    "CUSTOM_VIEWS_FOLDER": "Dossiers",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "Tous les contacts",
    "TAGGED_WITH": "Tagué avec",
    "NEW_LABEL": "Nouveau libellé",
    "NEW_TEAM": "Créer une équipe",
    "NEW_INBOX": "Nouvelle boîte de réception",
    "REPORTS_CONVERSATION": "Conversations",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campagnes",
    "ONGOING": "En cours",
    "ONE_OFF": "Isolées",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agents",
    "REPORTS_LABEL": "Étiquettes",
    "REPORTS_INBOX": "Boîte de réception",
    "REPORTS_TEAM": "Équipes",
    "REPORTS_PHONE": "Téléphone",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Vue d'ensemble",
    "WALLBOARD_QUEUES": "Files d'attente",
    "WALLBOARD_AGENTS": "Vue d'ensemble des agents",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Rapports",
    "NO_WAITING_CALLERS": "aucun appelant en attente",
    "WAITING_CALLERS": "{count} appelants en attente",
    "SET_AVAILABILITY_TITLE": "Se définir comme",
    "SET_YOUR_AVAILABILITY": "Définissez votre disponibilité",
    "AVAILABILITY_IMPERSONATING": "Verrouillé pendant la connexion en tant que cet utilisateur",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Nouvelle conversation",
    "DRAFT": "Brouillon",
    "BETA": "Bêta",
    "REPORTS_OVERVIEW": "Vue d'ensemble",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Centre d'aide",
      "ARTICLES": "Articles",
      "CATEGORIES": "Catégories",
      "LOCALES": "Langues",
      "SETTINGS": "Paramètres",
      "DICTIONARY": "Dictionnaire"
    },
    "CHANNELS": "Canaux",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Passer hors-ligne automatiquement",
      "INFO_TEXT": "Laissez le système vous passer automatiquement hors ligne lorsque vous n'utilisez pas l'application ou le tableau de bord.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Lire la documentation"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Domaines et contacts bloqués",
    "DESCRIPTION": "Liste des domaines e-mail bloqués pour ce compte.",
    "NO_BLOCKED_DOMAINS": "Aucun domaine bloqué trouvé.",
    "BLOCKED_CONTACTS_BTN": "Contacts bloqués"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Facturation",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Abonnement actuel",
      "PLAN_NOTE": "Vous êtes actuellement abonné à l'offre **{plan}** avec **{quantity}** licences",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Gérer votre abonnement",
      "DESCRIPTION": "Visualisez vos factures précédentes, modifiez vos coordonnées de facturation ou annulez votre abonnement.",
      "BUTTON_TXT": "Accéder au portail de facturation"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Besoin d'aide ?",
      "DESCRIPTION": "Vous avez des problèmes de facturation? Nous sommes là pour vous aider.",
      "BUTTON_TXT": "Discutez avec nous"
    },
    "NO_BILLING_USER": "Votre compte de facturation est en cours de configuration. Veuillez actualiser la page et réessayer."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Oh oh ! Nous n'avons pas trouvé de compte. Veuillez créer un nouveau compte pour continuer.",
    "NEW_ACCOUNT": "Nouveau compte",
    "SELECTOR_SUBTITLE": "Créer un nouveau compte",
    "API": {
      "SUCCESS_MESSAGE": "Compte créé avec succès",
      "EXIST_MESSAGE": "Ce compte existe déjà",
      "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nom de la société",
        "PLACEHOLDER": "Entreprises Wayne"
      },
      "SUBMIT": "Envoyer",
      "CANCEL": "Annuler"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Voir tous les raccourcis",
    "TITLE": {
      "OPEN_CONVERSATION": "Ouvrir la conversation",
      "RESOLVE_AND_NEXT": "Résoudre et passer à la suivante",
      "NAVIGATE_DROPDOWN": "Naviguer dans le menu déroulant",
      "RESOLVE_CONVERSATION": "Résoudre la conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Aller au tableau de bord des conversations",
      "ADD_ATTACHMENT": "Ajouter une pièce jointe",
      "GO_TO_CONTACTS_DASHBOARD": "Aller au tableau de bord des contacts",
      "TOGGLE_SIDEBAR": "Basculer la barre latérale",
      "GO_TO_REPORTS_SIDEBAR": "Aller à la barre latérale des rapports",
      "MOVE_TO_NEXT_TAB": "Passer à l'onglet suivant dans la liste des conversations",
      "GO_TO_SETTINGS": "Accéder aux paramètres",
      "SWITCH_TO_PRIVATE_NOTE": "Basculer vers une note privée",
      "SWITCH_TO_REPLY": "Basculer vers la réponse",
      "TOGGLE_SNOOZE_DROPDOWN": "Activer/désactiver la liste déroulante de répétition",
      "AI_ASSIST_MENU": "Assistant IA",
      "AI_ASSIST_GRAMMAR": "Corriger la grammaire",
      "AI_ASSIST_UNIFY_LANG": "Unifier la langue du message"
    }
  }
}
